module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "layout-breadcrumb"
  }, [_c('Breadcrumb', [_c('BreadcrumbItem', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "social-buffer-outline"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("采购业务流程")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-content-main",
    staticStyle: {
      "min-width": "980px",
      "padding": "20px",
      "margin-left": "60px"
    }
  }, [_c('div', {
    staticClass: "flowChart"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "startBorder"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/1-1.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("采购合同")])])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "5",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/1-2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("采购接收")])])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/1-3.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("采购入库")])])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/1-4.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("采购发票")])])], 1)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/1-5.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("付款申请")])])], 1)])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "flowPart",
    staticStyle: {
      "margin-left": "-30px",
      "margin-right": "15px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/2-1.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("平衡订货")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/2-2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("加工指示")])])], 1)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/2-3.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("加工排产")])])], 1)]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/2-4.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("加工工单")])])], 1)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/2-5.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("加工领料")])])], 1)]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/2-6.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("加工实绩")])])], 1)]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/2-3.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("加工入库")])])], 1)])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "30px",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "startBorder borderBottom"
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/3-1.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("销售订单")])])], 1)]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/3-2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("销售发货")])])], 1)]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "borderTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "borderLeft"
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/3-3.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("销售配车")])])], 1)]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/3-4.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("销售出库")])])], 1)]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/3-5.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("销售结算")])])], 1)]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/3-6.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("销售开票")])])], 1)]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "flowPart"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/3-7.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("销售收款")])])], 1)])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "flowPart",
    staticStyle: {
      "position": "absolute",
      "right": "85px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.doTry()
      }
    }
  }, [_c('Badge', {
    attrs: {
      "count": "0",
      "overflow-count": "99"
    }
  }, [_c('div', {
    staticClass: "flowList"
  }, [_c('span', {
    staticClass: "topImg"
  }), _vm._v(" "), _c('img', {
    staticClass: "imgContent",
    attrs: {
      "src": require("../../assets/icon/3-8.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flowInfo"
  }, [_vm._v("销售收款")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "flowChartRight"
  }, [_c('span', {
    staticClass: "rightTitle"
  }, [_vm._v("\n                 可视化跟踪查询\n               ")]), _vm._v(" "), _c('ul', {
    staticClass: "timeLine"
  }, [_vm._m(20), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "lineInfo"
  }, [_c('Icon', {
    attrs: {
      "type": "arrow-left-b"
    }
  }), _vm._v(" "), _c('span', [_vm._v("客户订货跟踪")])], 1)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "lineInfo"
  }, [_c('Icon', {
    attrs: {
      "type": "arrow-left-b"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n                        采购业务跟踪\n                      ")])], 1)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "lineInfo"
  }, [_c('Icon', {
    attrs: {
      "type": "arrow-left-b"
    }
  }), _vm._v(" "), _c('span', [_vm._v("生产业务跟踪")])], 1)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "lineInfo"
  }, [_c('Icon', {
    attrs: {
      "type": "arrow-left-b"
    }
  }), _vm._v(" "), _c('span', [_vm._v("机组负荷跟踪")])], 1)]), _vm._v(" "), _c('li', [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "lineInfo"
  }, [_c('Icon', {
    attrs: {
      "type": "arrow-left-b"
    }
  }), _vm._v(" "), _c('span', [_vm._v("产能预测")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox"
  }, [_c('div', {
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox"
  }, [_c('div', {
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox"
  }, [_c('div', {
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "22px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "12px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "2px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "2px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "2px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "22px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "12px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox"
  }, [_c('div', {
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowTop"
  }, [_c('div', {
    attrs: {
      "id": "triangle-facing-top"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "32px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBottom"
  }, [_c('div', {
    attrs: {
      "id": "triangle-facing-bottom"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "32px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "25px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "17px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "12px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "12px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBox",
    staticStyle: {
      "width": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "12px"
    },
    attrs: {
      "id": "triangle-facing-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrowBottom",
    staticStyle: {
      "height": "26px",
      "right": "115px",
      "top": "-27px",
      "margin-left": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "top": "17px"
    },
    attrs: {
      "id": "triangle-facing-bottom"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "logoBox",
    staticStyle: {
      "background": "linear-gradient(to bottom, rgb(50,70,149) 0%,rgb(20,20,60) 100%)"
    }
  }, [_c('img', {
    staticClass: "timeImg",
    attrs: {
      "src": require("../../assets/icon/time1-1.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBox",
    staticStyle: {
      "background": "linear-gradient(to bottom, rgb(0,167,245) 0%,rgb(0,60,190) 100%)"
    }
  }, [_c('img', {
    staticClass: "timeImg",
    staticStyle: {
      "left": "7px",
      "top": "5px"
    },
    attrs: {
      "src": require("../../assets/icon/time1-2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBox",
    staticStyle: {
      "background": "linear-gradient(to bottom, rgb(47,240,106) 0%,rgb(17,110,70) 100%)"
    }
  }, [_c('img', {
    staticClass: "timeImg",
    staticStyle: {
      "left": "5px",
      "top": "6px"
    },
    attrs: {
      "src": require("../../assets/icon/time1-3.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBox",
    staticStyle: {
      "background": "linear-gradient(to bottom, rgb(6,190,100) 0%,rgb(15,22,122) 100%)"
    }
  }, [_c('img', {
    staticClass: "timeImg",
    staticStyle: {
      "left": "4px",
      "top": "5px"
    },
    attrs: {
      "src": require("../../assets/icon/time1-4.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBox",
    staticStyle: {
      "background": "linear-gradient(to bottom, rgb(228,0,185) 0%,rgb(65,58,150) 100%)"
    }
  }, [_c('img', {
    staticClass: "timeImg",
    staticStyle: {
      "top": "6px",
      "left": "5px"
    },
    attrs: {
      "src": require("../../assets/icon/time1-5.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBox",
    staticStyle: {
      "background": "linear-gradient(to bottom, rgb(245,220,10) 0%,rgb(240,170,0) 100%)"
    }
  }, [_c('img', {
    staticClass: "timeImg",
    staticStyle: {
      "top": "6px"
    },
    attrs: {
      "src": require("../../assets/icon/time1-6.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-004be79e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Procurement/index.vue
// module id = 886
// module chunks = 1